import { render, staticRenderFns } from "./canvasRenderer.vue?vue&type=template&id=15b33650&lang=pug&"
import script from "./canvasRenderer.vue?vue&type=script&lang=js&"
export * from "./canvasRenderer.vue?vue&type=script&lang=js&"
import style0 from "./canvasRenderer.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports